export default "__VITE_ASSET__CCEGNvYR__"